import {
	 GATEWAY_FETCH,
	 GATEWAY_FETCH_SUCCESS,
	 GATEWAY_FETCH_FAIL,
} from '../actions';


export const gatewayFetch = (gatewaylist) => ({
	type: GATEWAY_FETCH,
	payload: { gatewaylist }
 });
 
 export const gatewaySuccess = (gatewaylist) => ({
	type: GATEWAY_FETCH_SUCCESS,
	payload: { gatewaylist }
 });
 
 export const gatewayFail = (message) => ({
	type: GATEWAY_FETCH_FAIL,
	payload: { message }
 });
 


